export const handleAddProject = (
  cnpj,
  setProjectAlert,
  company,
  clientAndProject,
  rateio,
  value,
  setTotalValueCnpj1,
  setTotalValueCnpj2,
  totalValueCnpj1,
  totalValueCnpj2,
  setTotalRateio,
  totalRateio,
  setTotalValueStatus,
  setProjects,
  setCompany,
  setRateio,
  setValue,
  projects,
  setDuplicateProjectError,
) => {
  if (cnpj === 0) {
    setProjectAlert(true);
    setTimeout(() => {
      setProjectAlert(false);
    }, 2000);
    return;
  }

  if (typeof projects !== 'undefined') {
    const equalProject = projects && projects.some((proj) => proj.clientAndProject === clientAndProject);
    if (equalProject) {
      setDuplicateProjectError(true);
      setTimeout(() => {
        setDuplicateProjectError(false);
      }, 2000);
      return;
    }
  }

  let project = {
    company: company,
    cnpj: cnpj,
    clientAndProject: clientAndProject,
    rateio: rateio,
    value: value,
  };

  setTotalValueCnpj1(cnpj === '1' ? (s) => s + value : totalValueCnpj1);
  setTotalValueCnpj2(cnpj === '2' ? (s) => s + value : totalValueCnpj2);
  setTotalRateio(totalRateio + rateio);
  setTotalValueStatus((v) => v + value);
  setProjects((s) => [...s, project]);
  setTimeout(() => {
    setCompany('');
    setRateio(0);
    setValue(0);
  }, 100);
};
